import difference from 'lodash/difference';
import isEmpty from 'lodash/isEmpty';
import union from 'lodash/union';

export default {
  mergeUniqueItemsIntoArray<T>(array1: T[], array2: T[]): T[] {
    return union(array1, array2);
  },

  removeCommonItemsFromArray<T>(
    arrayToRemoveFrom: T[],
    arrayWithItemsToRemove: T[]
  ): T[] {
    return difference(arrayToRemoveFrom, arrayWithItemsToRemove);
  },

  doArraysHaveSameItems<T>(array1: T[], array2: T[]): boolean {
    return isEmpty(difference(array1, array2));
  },
};
